module.exports = __webpack_public_path__ + "static/img/banner_1.e825efe.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/banner_1.jpg
// module id = UEPm
// module chunks = 1